<template>
  <div class="address-tab">
    <div
      :class="isActive === index ? 'address-tab-div1' : 'address-tab-div2'"
      v-for="(item, index) in tabList"
      :key="index"
      @click="titletabClick(index)"
    >
      {{ item }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tabList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      isActive: 0,
    };
  },
  methods: {
    titletabClick(index) {
      this.isActive = index;
      this.$emit("titletabChange", index)
    },
  },
};
</script>
<style lang="less" scoped>
.address-tab {
  width: 196px;
  height: 30px;
  display: flex;
  background: rgba(251, 251, 251, 1);
  border-radius: 1px;
  border: 1px solid rgba(54, 179, 116, 1);
  div {
    width: 98px;
    font-size: 14px;

    line-height: 30px;
    text-align: center;
  }
  &-div1 {
    background: rgba(54, 179, 116, 1);
    border-radius: 2px 0px 0px 2px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
  &-div2 {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(54, 179, 116, 1);
  }
}
</style>
